import { PRESETS, SpringPreset, stepSpring } from './springs';

// Push vector for a letter at (lx,ly) from pointer (px,py): away from the pointer,
// strength (1 - d/R) within radius R, capped at MAX. Returns {dx,dy} in px.
export const MAGNET_R = 80;
export const MAGNET_MAX = 18;
export function magnetPush(lx: number, ly: number, px: number, py: number, r = MAGNET_R, max = MAGNET_MAX) {
  const dx = lx - px, dy = ly - py;
  const d = Math.hypot(dx, dy);
  if (d >= r || d === 0) return { dx: 0, dy: 0 };
  const k = (1 - d / r) * max;
  return { dx: (dx / d) * k, dy: (dy / d) * k };
}

// Peak displacement of a spring kicked from rest is linear in the kick velocity, so measure it
// once with the real integrator at 60fps (bounded 120-step sim) and invert: the returned
// speed (px/s) makes a flick scatter peak at `peak` px.
export const FLICK_PEAK = 120;
const PROBE_V = 1000;
const peakCache = new Map<SpringPreset, number>();
function peakPerVelocity(p: SpringPreset): number {
  const hit = peakCache.get(p);
  if (hit !== undefined) return hit;
  let s = { x: 0, v: PROBE_V };
  let peak = 0;
  for (let i = 0; i < 120; i++) { s = stepSpring(s, 0, 1 / 60, p); peak = Math.max(peak, Math.abs(s.x)); }
  const k = Math.max(1e-6, peak / PROBE_V);
  peakCache.set(p, k);
  return k;
}
export function flickSpeed(peak = FLICK_PEAK, p: SpringPreset = PRESETS.bouncy): number {
  return peak / peakPerVelocity(p);
}
